import Breadcrumbs from '@v2/shared/components/Breadcrumbs';
import ContentCard from '@v2/shared/components/ContentCard';
import PageHeading from '@v2/shared/components/PageHeading';
import { liveAgentClockLong } from '@v2/shared/lib/supportHours';

/** /accessibility. */
export default function Accessibility() {
  return (
    <>
      <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Accessibility' }]} />

      <PageHeading eyebrow="Customer Information">Accessibility Statement</PageHeading>

      <div className="prose mt-6 flex flex-col gap-6">
        <ContentCard>
          <h2>General</h2>
          <p>
            DiscountMags.com is committed to ensuring that its services are accessible to people
            with disabilities. We have invested a significant amount of resources to help ensure
            that our website is made easier to use and more accessible for people with disabilities,
            with the strong belief that every person has the right to live with dignity, equality,
            comfort, and independence.
          </p>
        </ContentCard>

        <ContentCard>
          <h2>Accessibility on DiscountMags.com</h2>
          <p>
            DiscountMags.com is actively working to increase its compliance with the Web Content
            Accessibility Guidelines (WCAG 2.1) Level AA. We have engaged in an internal audit of
            our digital assets and are dedicating resources to continuous remediation of any
            accessibility issues identified.
          </p>
        </ContentCard>

        <ContentCard>
          <h2>Disclaimer</h2>
          <p>
            We continue to work to improve the accessibility of our site and services in the belief
            that it is our collective moral obligation to allow seamless, accessible, and unhindered
            use also for those of us with disabilities.
          </p>
          <p>
            Despite our efforts to make all pages and content on DiscountMags.com fully accessible,
            some content may not have yet been fully adapted to the strictest accessibility
            standards. This may be a result of not having found or identified the most appropriate
            technological solution.
          </p>
        </ContentCard>

        <ContentCard>
          <h2>Here For You</h2>
          <p>
            If you are experiencing difficulty with any content on DiscountMags.com or require
            assistance with any part of our site, please contact us during normal business hours as
            detailed below and we will be happy to assist.
          </p>
        </ContentCard>

        <ContentCard>
          <h2>Contact Us</h2>
          {/*
           * This paragraph deliberately carries no bottom margin: it runs straight into
           * the list it introduces, which is how the page reads today.
           */}
          <p className="mb-0">
            If you wish to report an accessibility issue, have any questions, or need assistance,
            please contact DiscountMags.com Customer Support as follows:
          </p>
          <ul>
            <li>
              <strong>Email:</strong> <a href="mailto:help@discountmags.com">help@discountmags.com</a>
            </li>
            <li>
              <strong>Phone:</strong> <a href="tel:+18006738187">1-800-673-8187</a>
            </li>
            <li>
              <strong>Hours:</strong> Monday - Friday: {liveAgentClockLong()} (CST), Saturday -
              Sunday:Closed
            </li>
          </ul>
        </ContentCard>
      </div>
    </>
  );
}

Accessibility.layoutName = 'Layouts.Institutional';
